// src/components/results/views/quality.js

// export function pickHrBpm(docData) {
//   const d = docData || {};

//   // CPP is canonical now
//   const cpp =
//     d?.results?.cpp?.data?.hr_bpm ??
//     d?.results?.cpp?.data?.hrBpm ??
//     d?.results?.cpp?.hr_bpm ??
//     d?.results?.cpp?.hr ??
//     null;

//   if (typeof cpp === "number" && Number.isFinite(cpp)) return Math.round(cpp);

//   return null;
// }
function normalizeHrSignalQualityValue(raw) {
  const value = typeof raw === "string" ? raw.trim().toLowerCase() : null;
  if (!value) return null;

  if (value === "very good" || value === "very_good" || value === "verygood") {
    return "very good";
  }

  if (
    value === "good" ||
    value === "pass" ||
    value === "passed" ||
    value === "ok"
  ) {
    return "good";
  }

  if (
    value === "bad" ||
    value === "fail" ||
    value === "failed" ||
    value === "low" ||
    value === "poor"
  ) {
    return "bad";
  }

  return null;
}

function mapHrSignalQualityScore(score) {
  if (typeof score !== "number" || !Number.isFinite(score)) return null;
  if (score >= 90) return "very good";
  if (score >= 80) return "good";
  return "bad";
}

export function isPassingHrSignalQuality(quality) {
  return quality === "good" || quality === "very good";
}

/**
 * HR signal quality normalisation.
 * Return: "very good" | "good" | "bad" | null
 *
 * Priority:
 *  1) HeartDx categorical quality fields
 *  2) HeartDx numeric score fallback
 *  3) legacy doc-level fields
 */
export function pickHrSignalQuality(docData) {
  const d = docData || {};

  const categoricalCandidates = [
    d?.results?.heartdx?.data?.rppg_signal_quality,
    d?.results?.heartdx_signal_quality,
    d?.results?.heartdx?.rppg_signal_quality,
    d?.rppg_signal_quality,
    d?.ppg_signal_quality,
    d?.heartdx?.ppg_signal_quality,
    d?.signal_quality_text,
    d?.signalQualityText,
  ];

  for (const candidate of categoricalCandidates) {
    const normalized = normalizeHrSignalQualityValue(candidate);
    if (normalized) return normalized;
  }

  const scoreCandidates = [
    d?.results?.heartdx_signal_quality_score,
    d?.results?.heartdx?.data?.heartdx_signal_quality_score,
    d?.results?.heartdx?.data?.sqi,
  ];

  for (const candidate of scoreCandidates) {
    const normalized = mapHrSignalQualityScore(candidate);
    if (normalized) return normalized;
  }

  const legacyCode = d?.signal_quality_code ?? d?.signalQualityCode ?? null;
  if (typeof legacyCode === "number" && Number.isFinite(legacyCode)) {
    return legacyCode <= 1 ? "bad" : "good";
  }

  return null;
}

export function pickRr(docData) {
  const r = docData?.results || docData?.resp?.results || null;
  const rrRaw =
    r?.mpm?.rr_avg ??
    r?.Respiratory_rate ??
    r?.respiratory_rate ??
    // r?.rgb_respiratory_rate ??
    // docData?.rgb_respiratory_rate ??
    // docData?.Respiratory_rate ??
    null;

  return typeof rrRaw === "number" && Number.isFinite(rrRaw) ? rrRaw : null;
}

export function pickRrSignalQuality(docData) {
  const r = docData?.results || docData?.resp?.results || null;
  const sqRaw = r?.mpm?.quality ?? null;

  const s = typeof sqRaw === "string" ? sqRaw.trim().toLowerCase() : null;
  return s === "pass" || s === "fail" ? s : null;
}
